$(function () {
	$('.page-main__banner-divider svg').click(function() {
		TweenLite.to(window, 1, {scrollTo:"#scroll"});
	});
});
